import React from "react";
import Container from "@ui/container"
import { MessageBoxContent } from "@widgets/message-box";
import ItemShortSummary from "@widgets/item-short-summary";
import { LinkButtonPrimary, LinkButtonPrimaryBorder } from "@ui/buttons";

const ItemStatusCard = ({ data }) => {
    const {
        viewLink,
        accountLink,
        statusDisplayType,
        statusText
    } = data;

    let links = [];
    if (viewLink)
        links = [viewLink]
    if (accountLink)
        links = [...links, accountLink]

    console.log(links);

    return (
        <Container>
            <div className="rounded-md bg-white max-w-lg p-4">
                {statusDisplayType &&
                    <div className="m-4">
                        <MessageBoxContent
                            data={{
                                messageType: statusDisplayType,
                                value: statusText,
                                imgContainerClass: "hidden",
                                textContainerClass: "w-full text-center"
                            }}
                        />                    </div>
                }
                <ItemShortSummary data={data} />
                <div className="p-4 flex flex-wrap gap-4">
                    {links.map((link, idx) => {
                        return idx === 0 ? (
                                <LinkButtonPrimary
                                    key={link.text}
                                    className="text-center w-full xs:w-auto"
                                    {...link}
                                >
                                    {link.text}
                                </LinkButtonPrimary>
                            )
                            : (
                                    <LinkButtonPrimaryBorder
                                        className="text-center w-full xs:w-auto"
                                        key={link.text}
                                        {...link}
                                    >
                                        {link.text}
                                    </LinkButtonPrimaryBorder>
                                )
                    })
                    }
                </div>
            </div>
        </Container>
    );
};
export default ItemStatusCard;
